export const OFFER_STATUSES = Object.freeze([
  { key: "open", value: "offen", label: "In Bearbeitung / offen" },
  { key: "sent", value: "versendet", label: "Versendet" },
  { key: "won", value: "gewonnen", label: "Gewonnen" },
  { key: "rejected", value: "abgesagt", label: "Abgesagt" },
]);

const OFFER_STATUS_VALUES = new Set(OFFER_STATUSES.map(({ value }) => value));

export function offerStatus(offer) {
  // Compatibility rule for records created before the dedicated sent state.
  return offer?.entscheid === "offen" && offer?.datumVersand ? "versendet" : offer?.entscheid;
}

export function canMoveOffer(from, to) {
  return (
    from !== to && OFFER_STATUS_VALUES.has(from) && OFFER_STATUS_VALUES.has(to)
  );
}

export function offerStatusPatch(
  offer,
  status,
  today = new Date(),
  selectedDecisionDate = offer.entscheidDatum,
) {
  const date = today.toISOString().slice(0, 10);
  const shippingDate = offer.datumVersand || date;
  if (status === "offen")
    return {
      entscheid: "offen",
      datumVersand: null,
      entscheidDatum: null,
      entscheidKommentar: null,
    };
  if (status === "versendet")
    return {
      entscheid: "versendet",
      datumVersand: shippingDate,
      entscheidDatum: null,
      entscheidKommentar: null,
    };
  return {
    entscheid: status,
    datumVersand: shippingDate,
    entscheidDatum: selectedDecisionDate || date,
    entscheidKommentar: status === "gewonnen" ? "Zusage" : "Absage",
  };
}
